import img65 from './EquipoMedico/img65.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Neonatologia extends Component {
    render() {
        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Neonatología</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Centramos la información en una columna de 8/12 para monitores
                        y permitimos que crezca en tablets (10/12) */}
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <Card className="shadow border-0 text-center">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img65} 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto', 
                                            maxHeight: '900px', // Un poco más alto para facilitar la lectura del texto
                                            objectFit: 'contain' 
                                        }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                        Sala para partos
                                    </Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}